import { sortTypeEnum } from '@/constants/global';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
const state = {
    filterOption: {
        pageNumber: 1,
        pageSizeType: pageSizeEnum['50'],
        hubStatusType: '',
        searchWord: {
            // 검색유형
            field: '',
            // 검색어
            value: '',
            // 검색조건
            condition: 'like',
        },
    },
    hubList: [],
    paginationData: {
        pageNumber: 0,
        pages: 0,
        total: 0,
    },
    sortOption: [
        {
            // 정렬 대상
            field: 'name',
            // 정렬 기준
            value: sortTypeEnum.ASC,
        },
    ],
};
export default state;
